// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__RNXAu"};